import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * 器械/装备类型英文 → 中文映射
 */
export const EQUIPMENT_LABELS: Record<string, string> = {
  barbell: '杠铃',
  dumbbell: '哑铃',
  machine: '固定器械',
  bodyweight: '自重',
  cable: '绳索器械',
  kettlebell: '壶铃',
  'resistance-band': '弹力带',
  'foam-roller': '泡沫轴',
};

export function equipmentLabel(equip?: string | null): string {
  if (!equip) return '';
  return EQUIPMENT_LABELS[equip] ?? equip;
}

/**
 * RPE 数值映射为通俗强度文案
 * - 5~6 → 轻松练·做完还有力气
 * - 7~8 → 适中·做完剩2-3次余力
 * - 9 → 较难·快到极限
 * - 10 → 练到力竭
 * - 其他 → 适中
 */
export function rpeToIntensity(rpe: number | undefined | null): string {
  if (rpe == null || Number.isNaN(rpe)) return '适中';
  if (rpe <= 0) return '适中';
  if (rpe < 7) return '轻松练·做完还有力气';
  if (rpe < 9) return '适中·做完剩2-3次余力';
  if (rpe === 9) return '较难·快到极限';
  if (rpe >= 10) return '练到力竭';
  return '适中';
}

/**
 * 本地日期格式化 YYYY-MM-DD（按用户本地时区，不是 UTC）
 * 🔴 打卡、日历等「跟本地自然日对齐」的场景必须用这个，不能用 toISOString().slice(0,10)
 *    否则 UTC+8 时区每天 0:00–7:59 的打卡会被记到前一天
 */
export function formatLocalDate(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
